import React from 'react';
import { PageHero, CTASection } from '@/components/shared/Section';
import { WHY_US } from '@/data/content';
import { Award, Layers, Network } from 'lucide-react';

export default function WhyChooseUsPage() {
  return (
    <>
      <PageHero
        eyebrow="Why TITO"
        title="The partner businesses choose when execution actually matters."
        description="Six reasons why ambitious founders, operators and HR leaders pick TITO as their growth and workforce partner."
      />

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {WHY_US.map((w, i) => (
            <div
              key={w.title}
              data-testid={`why-card-${i}`}
              className="group relative rounded-sm border border-slate-200 bg-white p-8 transition-all hover:-translate-y-1 hover:shadow-xl"
            >
              <div className="absolute top-6 right-6 font-display font-bold text-5xl text-slate-100 group-hover:text-tito-gold/20 transition-colors">
                0{i + 1}
              </div>
              <div className="relative">
                <div className="h-10 w-1 bg-tito-gold rounded-sm" />
                <h3 className="mt-5 font-display font-semibold text-xl text-slate-900">{w.title}</h3>
                <p className="mt-3 text-sm text-slate-600 leading-relaxed">{w.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-white border-y border-slate-200">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-24">
          <div className="grid lg:grid-cols-3 gap-6">
            {[
              { icon: Award, t: 'Quality over quantity', d: 'Curated talent. Curated advice. Curated partnerships.' },
              { icon: Layers, t: 'Integrated services', d: 'Hire, brand, set up, and scale — under one roof.' },
              { icon: Network, t: 'GCC-ready network', d: 'Built for the realities of Dubai and the wider GCC.' },
            ].map(({ icon: Icon, t, d }) => (
              <div key={t} className="p-8 rounded-sm bg-[#F8FAFC] border border-slate-200">
                <Icon className="h-6 w-6 text-tito-gold" />
                <h4 className="mt-5 font-display font-semibold text-xl text-slate-900">{t}</h4>
                <p className="mt-2 text-slate-600 leading-relaxed">{d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
